import React from 'react';
import axios from 'axios';
import axiosUrl from '../../axios/url';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



export default function ProgramEditDialog(param) {

    const [projectId, setProjectId] = React.useState('');
    const [programId, setProgramId] = React.useState('');

    // 화면에 보여지는 항목들
    const [name, setName] = React.useState('');                     // 프로그램 명

    // const [durationValue, setDurationValue] = React.useState('');   // 제공기간 (db변수)
    // const [durationType, setDurationType] = React.useState('');     // 제공기간 (db변수)
    const [duration, setDuration] = React.useState('');             // 제공기간 (화면변수)

    // const [startPoint, setStartPoint] = React.useState('');         // 가입기준 (db변수)
    const [startPointView, setStartPointView] = React.useState('');         // 가입기준 (화면변수)

    const [startDate, setStartDate] = React.useState('');           // 판매기간 (db변수)
    const [endDate, setEndDate] = React.useState('');               // 판매기간 (db변수)
    //const [startEndDate, setStartEndDate] = React.useState('');     // 판매기간 (화면변수)

     // 프로그램 정보 조회
     async function getProgram(){
        var url = axiosUrl.project + '/' + param.projectId + '/programs/' + param.programId;
        await axios.get(url)
        .then( response => {
            // 프로그램 명
           var result = response.data;
           if(result){
                setName(result.name);

                //----- 제공기간 세팅
                var durVal = result.durationValue + result.durationType;
                if(durVal == '1YEAR') {
                    setDuration('1');
                }else if(durVal == '6MONTH') {
                    setDuration('2');
                }else if(durVal == '3MONTH') {
                    setDuration('3');
                }
    
                //----- 가입기준 세팅
                var spVal = result.startPoint;
                
                if(spVal == 'TODAY') {
                    //setStartPoint('1');
                    setStartPointView('1');
                }
                else if(spVal == 'TOMORROW') {
                    //setStartPoint('2');
                    setStartPointView('2');
                }
    
                //---- 판매기준 세팅
                setStartDate(new Date(result.startDate));
                setEndDate(new Date(result.endDate));
           }
        })
        .catch(function (e) {
            console.error('[MEDIEX_CMS_2019_ERROR] ProgramEditDialog.getProgram - ' + e.response.data.error.messagee);
        });
    }


    // 프로그램 변경
    async function saveProgram(){
        // 제공기간
        var duVal = document.getElementById('durationV').value;
        var dvVal = '';
        var dtVal = '';
        if(duVal == '1'){
            dvVal = '1';
            dtVal = 'YEAR';
        }else if(duVal == '2'){
            dvVal = '6';
            dtVal = 'MONTH';
        }else if(duVal == '3'){
            dvVal = '3';
            dtVal = 'MONTH';
        }else { }

        // 판매기간 확인
        const sDate = date_to_str(startDate);
        const eDate = date_to_str(endDate);

        // 가입기준
        var startVal = document.getElementById('startPointV').value;
        var pointVal = '';
        if(startVal == '1'){
            pointVal = 'TODAY';
        }else if(startVal == '2'){
            pointVal = 'TOMORROW';
        }else{ }

        var url = axiosUrl.project + '/' + param.projectId + '/programs/' + param.programId;
        await axios.put(url,{
            name: name,
            durationValue: dvVal,
            durationType: dtVal,
            startPoint: pointVal,
            startDate: sDate,
            endDate: eDate,
            priority: 2,
        })
        .then(function (response){
            // 프로젝트 리스트 정보 전체를 새로 내려받아 화면 업데이트
            param.callbackUpdateList();
            document.getElementById('programEditClose').click();
        })
        .catch(function (e) {
            alert('프로그램 정보 변경에 실패하였습니다. 다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] ProgramEditDialog.saveProgram - ' + e.response.data.error.message);
        });

    }

     // 날짜 포멧 변경
     function date_to_str(format){
        var year = format.getFullYear();
        var month = format.getMonth() + 1;
        if(month<10) month = '0' + month;
        var date = format.getDate();
        if(date<10) date = '0' + date;

        return year + "-" + month + "-" + date;
}

    // 프로그램 삭제
    async function deleteProgram(){
        if(!window.confirm('프로젝트를 삭제하시겠습니까?')) return;
        
        var url = axiosUrl.project + '/' + projectId + '/programs/' + programId;
        await axios.delete(url)
        .then(function (response){
            // 프로젝트 리스트 정보 전체를 새로 내려받아 화면 업데이트
            param.callbackUpdateList();
            document.getElementById('programEditClose').click();
         })
        .catch(function (e) {
            alert('프로그램 삭제에 실패하였습니다. 다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] ProejctEditDialog.deleteProgram - ' + e.response.data.error.message);
        });
    }

    // 프로그램명 세팅
    function onChangeName(e){
        setName(e.target.value);
    }

    // 제공기간 세팅
    function onChangeDuration(e){
        var val = e.target.value;
        if(val == '1'){
            setDuration(val);//YEAR
        }else if(val == '2'){//MONTH
            setDuration(val);
        }else if(val == '3'){//MONTH
            setDuration(val);
        }else { }

    }
  
    // 가입기준 세팅
    function onChangeStartPoint(e){
        var val = e.target.value;
        if(val == '1'){
            setStartPointView(val); //TODAY
        }else if(val == '2'){
            // setStartPointView(val);/TOMORROW
        }else{ }
    }

    function reset(){
        getProgram();
    }

    //function handleStartEndDate(e){
        // daterangepicker가 value 값을 넣어놓고 onchange함수를 호출하지 않으면 오류가 남.
        // 그냥 빈 함수 만들어서 onchange 이벤트 받고 있음.
    //}

    React.useEffect(() => {
        if(programId !== param.programId) {
            setProjectId(param.projectId);
            setProgramId(param.programId);
            getProgram();
        }
    });

    return(
        <div className="modal fade" id="ProgramEditDialog" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            
            <div className="modal-dialog   modal-dialog-centered" role="document">
                <div className="modal-content">
                <div className="modal-header contentColor">
                    <h5 className="modal-title" id="exampleModalLabel">프로그램 변경하기</h5>
                    <button type="button" id='programEditClose' className="close" data-dismiss="modal" onClick={reset} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="input-group mb-3">
                        프로그램  <input type="text" className="form-control ml-4" onChange={onChangeName} value={name} />
                    </div>

                    <div className="input-group mb-3">
                        제공기간  
                            <select id="durationV" value={duration} className="custom-select ml-4" onChange={onChangeDuration} >
                                <option value="1" >1년</option>
                                <option value="2" >6개월</option>
                                <option value="3" >3개월</option>
                            </select>
                    </div>

                    <div className="input-group mb-3">
                        가입기준  
                            <select id="startPointV" value={startPointView} className="custom-select ml-4" onChange={onChangeStartPoint} >
                                <option value="1" >오늘</option>
                                <option value="2" >내일</option>
                            </select>
                    </div>

                    <div className="input-group mb-3">
                        판매기간
                      
                            <DatePicker
                                type='text'
                                className="dateRangePicker form-control ml-4"
                                id='startDate'
                                selected={startDate}
                                onChange={date => setStartDate(date)}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                dateFormat="yyyy-MM-dd"
                                placeholderText='시작일을 지정하세요'
                            />
                            <DatePicker
                                className="dateRangePicker form-control ml-2"
                                id='endDate'
                                selected={endDate}
                                onChange={date => setEndDate(date)}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                                dateFormat="yyyy-MM-dd"
                                placeholderText='종료일을 지정하세요'
                        />
                    </div>

                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={reset} >닫기</button>
                    <button type="button" className="btn btn-danger" onClick={deleteProgram}>삭제</button>
                    <button type="button" className="btn btn-primary" onClick={saveProgram}>저장</button>
                </div>
                </div>
            </div>
            </div>

    );
}